import { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Landing from './screens/Landing';

// Code-split everything past the landing screen.
const Categories = lazy(() => import('./screens/Categories'));
const TemplateBrowser = lazy(() => import('./screens/TemplateBrowser'));
const TemplateDetails = lazy(() => import('./screens/TemplateDetails'));
const MediaPicker = lazy(() => import('./screens/MediaPicker'));
const Generating = lazy(() => import('./screens/Generating'));
const PreviewPlayer = lazy(() => import('./screens/PreviewPlayer'));
const Editor = lazy(() => import('./screens/Editor'));
const MyProjects = lazy(() => import('./screens/MyProjects'));
const AiTemplate = lazy(() => import('./screens/AiTemplate'));

function ScreenFallback() {
  return (
    <div className="flex h-dvh items-center justify-center">
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-brand-500 border-t-transparent" />
    </div>
  );
}

export default function App() {
  return (
    <AnimatePresence mode="wait">
      <Suspense fallback={<ScreenFallback />}>
        <Routes>
          {/* Screen 1 — Landing */}
          <Route path="/" element={<Landing />} />
          {/* Screen 2 — Template categories */}
          <Route path="/categories" element={<Categories />} />
          {/* Screen 3 — Template browser (grid), optionally filtered */}
          <Route path="/templates" element={<TemplateBrowser />} />
          <Route path="/templates/category/:categoryId" element={<TemplateBrowser />} />
          {/* Screen 4 — Template details */}
          <Route path="/templates/:templateId" element={<TemplateDetails />} />
          {/* AI actor templates — face + text, one reusable component */}
          <Route path="/ai/:templateId" element={<AiTemplate />} />
          {/* Screen 5 — Media picker */}
          <Route path="/create/:templateId/media" element={<MediaPicker />} />
          {/* Screen 6 — Generating progress */}
          <Route path="/create/:templateId/generating/:jobId" element={<Generating />} />
          {/* Screen 7 — Preview player */}
          <Route path="/create/:templateId/preview/:jobId" element={<PreviewPlayer />} />
          {/* Screen 8 — Video editor */}
          <Route path="/editor/:projectId" element={<Editor />} />
          {/* My projects */}
          <Route path="/projects" element={<MyProjects />} />
        </Routes>
      </Suspense>
    </AnimatePresence>
  );
}
